
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftBottom50 as ObiThreewayAnalogInleftBottom50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-bottom-50.js';
 
 
 

 
 export const ObiThreewayAnalogInleftBottom50 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-bottom-50',
   elementClass: ObiThreewayAnalogInleftBottom50Element,
   events: {
     
   }
  });
 
 